// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Vector2, IVector2 } from "./System.Numerics.Vector2.gen";

export interface IScreenLine {
	points: IVector2[] | undefined;

	id: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	inboundDirection: number | undefined;

	outboundDirection: number | undefined;

	name: string | undefined;

	reverseInOut: boolean | undefined;

	$type?: string | undefined;
}
export class ScreenLine {
	constructor(data?: IScreenLine) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.points = data.points ? data.points.map((p: any) => new Vector2(p)) : [];
	}

	points: Vector2[] | undefined = [];

	id: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	inboundDirection: number | undefined;

	outboundDirection: number | undefined;

	name: string | undefined;

	reverseInOut: boolean | undefined;

	static $type: string = "CoreApi.Models.ScreenLine, ";
	$type?: string | undefined = ScreenLine.$type;
}

